// extracted by mini-css-extract-plugin
export default {"cFormBox":"CForm_cFormBox__effm5","cFormContent":"CForm_cFormContent__mdDLo","cForm":"CForm_cForm__VRi8G","submitBtns":"CForm_submitBtns__q3L76"};